import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'
import { colors } from '../../util/colors'

export const styles = {
  navbar: {
    display: 'flex',
    flexDirection: 'column',
    // minWidth: 325,
    width: '90vw',
    h: '100vh',
    backgroundColor: 'WHITE',
  } as BoxProps,
  cancel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: 24,
  } as BoxProps,
  arrowRight: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'WHITE',
    borderRadius: 16,
    height: 32,
    width: 32,
    // Todo
    boxShadow: '0px 10px 20px #E0E0E0',
  } as BoxProps,
  itemContainer: {
    flexDirection: 'row',
    pv: 16,
    underlayColor: 'TRANSPARENT',
    align: 'center',
  } as BoxProps,
  footerView: {
    flexDirection: 'column',
    backgroundColor: '#0070B60F' as ColorOptions,
    justifyContent: 'space-between',
    pv: 25,
    mt: 25,
  } as BoxProps,
  googlePlayView: {
    flexDirection: 'row',
    pl: 32,
    pt: 16,
  } as BoxProps,
  leftImgContainer: {
    flexDirection: 'row',
  } as BoxProps,
  jioBizImageContainer: {
    justifyContent: 'flex-start',
    position: 'absolute',
    left: 24,
    pl: 0,
    top: -48,
  } as BoxProps,
  businessAppContainer: {
    ph: 32,
    pt: 80,
    flex: 1,
  } as BoxProps,
  boldHeader: (hide: boolean) =>
    ({
      fontSize: 16,
      color: colors.HIGHLIGHT,
      fontFamily: hide ? 'jiotype-medium' : 'jiotype-bold',
      fontWeight: 'bold',
    } as TextNewProps),
  footerDescription: {
    fontSize: 12,
    color: 'LIGHT_GREY',
    fontFamily: 'jiotype-medium',
    lineHeight: 17,
  } as TextNewProps,
  underlayedTrans: {
    underlayColor: 'TRANSPARENT',
    alignSelf: 'flex-start',
    borderRadius: 6,
    height: 32,
    overflow: 'hidden',
  } as BoxProps,
  imgStyle: {
    width: 110,
    height: '99%',
    overflow: 'hidden',
  },
}
